import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        flex-wrap: wrap;
        gap: 0.2em;
        justify-content: space-evenly;
    }

    ds-media {
        width: 6em;
        height: 6em;
        cursor: pointer;
    }

    ds-media::part(image),
    ds-media::part(video) {
        object-fit: cover;
        border-radius: 0.4em;
    }
`;
